import './number-link.css';
import { __rest } from '../../_virtual/_tslib.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import styles from './number-link.module.scss.js';

/**
 * @ignore
 */
const NumberLink = (props) => {
    const { href, children, onClick, pageNumber: pageNumberProp, surface = 'lightPrimary', isSelected, ariaLabel, screenReaderLabel } = props, rest = __rest(props, ["href", "children", "onClick", "pageNumber", "surface", "isSelected", "ariaLabel", "screenReaderLabel"]);
    const _onKeyDown = (e) => {
        if (e.key === 'Enter' || e.type === 'click' || e.key === ' ') {
            e.preventDefault();
            onClick === null || onClick === void 0 ? void 0 : onClick(pageNumberProp, e);
        }
    };
    const _onClick = (e) => {
        if (e.type === 'click') {
            e.preventDefault();
            onClick === null || onClick === void 0 ? void 0 : onClick(pageNumberProp, e);
        }
    };
    const role = href ? 'link' : 'button';
    const compProps = {
        active: isSelected.toString(),
        surface,
        'aria-label': ariaLabel,
        href: role === 'link' ? href : undefined,
        role,
        onClick: role === 'button' ? _onClick : undefined,
        onKeyDown: role === 'button' ? _onKeyDown : undefined,
        tabIndex: 0,
        'aria-current': isSelected,
    };
    const child = (jsxs(Fragment, { children: [jsx("span", { className: styles.numberSpan, children: children }), jsx("span", { className: styles.screenreaderText, "aria-live": isSelected ? 'assertive' : undefined, children: screenReaderLabel })] }));
    const classes = [styles.numberLink, styles[surface.toLowerCase()]];
    if (isSelected)
        classes.push(styles.selected);
    const Element = href ? 'a' : 'button';
    return (jsx(Element, Object.assign({}, compProps, { className: classes.join(' ') }, rest, { children: child })));
};

export { NumberLink as default };
